<app-modal-shell
  [isOpen]="isOpen"
  title="Data de exames e conselho"
  [panelClass]="'max-w-[24rem] w-[92vw] px-0 sm:px-0'"
  [bodyClass]="'p-0'"
  [closeOnBackdropClick]="false"
  (fechado)="onClose()">
  
  <div class="flex flex-col max-h-[75vh]">
    <div class="overflow-y-auto px-5 py-2">
      <div *ngFor="let item of itens" class="flex flex-row items-center justify-between py-3.5 border-b border-gray-200 dark:border-gray-700 last:border-0 gap-4">
        
        <span class="text-[15px] font-medium text-gray-700 dark:text-gray-200 line-clamp-2 break-words flex-1">
          {{ item.descricao }}
        </span>
        
        <div class="w-[165px] shrink-0 relative">
          
          <div *ngIf="item.salvando" class="absolute inset-0 z-10 bg-white/60 dark:bg-gray-800/60 flex items-center justify-center rounded">
            <lucide-icon name="loader-2" class="w-5 h-5 animate-spin text-[#4b5bdc]"></lucide-icon>
          </div>

          <app-datepicker
            variant="inline"
            [dataSelecionada]="converterStringParaData(item.data)"
            [showClearIcon]="true"
            placeholder="DD/MM/AAAA"
            (dateChange)="onDataAlterada(item, $event)">
          </app-datepicker>
          
        </div>
      </div>
      
      <div *ngIf="itens.length === 0" class="text-center py-8 text-sm text-gray-500 dark:text-gray-400">
        Nenhum item de exame ou conselho disponível.
      </div>
    </div>
    
    <div class="px-5 py-4 w-full bg-white dark:bg-gray-800 rounded-b-2xl border-t border-gray-100 dark:border-gray-700/50">
      <button 
        type="button" 
        (click)="onClose()" 
        class="w-full block px-4 py-2.5 text-[13px] font-medium text-gray-600 bg-white border border-gray-300 rounded-lg hover:bg-gray-50 dark:bg-gray-800 dark:text-gray-300 dark:border-gray-600 dark:hover:bg-gray-700 transition-colors uppercase tracking-wide text-center">
        Fechar
      </button>
    </div>
  </div>
</app-modal-shell>
